var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-step-editor-sidebar-media-uploading"},[_c('shared-step-editor-loader',{attrs:{"size":50}}),_vm._v(" "),_c('span',[_vm._v("UPLOADING")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }